import { render, staticRenderFns } from "./DefCity.vue?vue&type=template&id=f65cbea6&scoped=true&"
import script from "./DefCity.vue?vue&type=script&lang=js&"
export * from "./DefCity.vue?vue&type=script&lang=js&"
import style0 from "./DefCity.vue?vue&type=style&index=0&id=f65cbea6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65cbea6",
  null
  
)

export default component.exports